import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';

interface PaymentStatusBadgeProps {
  status: string;
  className?: string;
}

export function PaymentStatusBadge({ status, className }: PaymentStatusBadgeProps) {
  const { t } = useTranslation();
  const label = t(`payments.status.${status}`, { defaultValue: status });

  const tone =
    status === 'succeeded'
      ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
      : status === 'failed'
        ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400'
        : status === 'pending' || status === 'processing'
          ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400'
          : status === 'refunded' || status === 'partially_refunded'
            ? 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400'
            : 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        tone,
        className,
      )}
    >
      {label}
    </span>
  );
}
